import React, { createContext, useContext, useState, ReactNode } from 'react';
import { Language, Translations } from '../types';

const en: Translations = {
  nav: {
    about: 'About',
    experience: 'Experience',
    youtube: 'YouTube',
    blog: 'Blog',
    contact: 'Contact',
  },
  hero: {
    greeting: "Hi, I'm",
    title: 'Senior Full Stack Software Developer',
    bio: 'Building scalable web & mobile applications with passion. Based in Amsterdam, Netherlands — originally from Istanbul.',
    cta: 'View My Work',
  },
  about: {
    title: 'About',
    subtitle: 'A bit about me',
    description:
      'I\'m a Senior Full Stack Software Developer with over a decade of experience crafting digital products. From game development and mobile apps to large-scale web platforms, I\'ve worn many hats. Currently based in Amsterdam, I bring a versatile skill set spanning JavaScript, React Native, Node.js, .NET, 3D/WebGL, and more.',
    skillsTitle: 'Skills & Technologies',
    locationLabel: 'Location',
    location: 'Amsterdam, Netherlands',
  },
  experience: {
    title: 'Experience',
    subtitle: 'My professional journey',
    present: 'Present',
  },
  youtube: {
    title: 'YouTube',
    subtitle: 'Educational content & tutorials',
    watchBtn: 'Watch Video',
    channelBtn: 'View Channel',
    stats: '1.92K subscribers · 19 videos · 200K+ views',
  },
  blog: {
    title: 'Blog',
    subtitle: 'Thoughts & articles',
    comingSoon: 'Coming Soon',
    comingSoonDesc: 'I\'m working on some articles about software development, architecture, and my experiences. Stay tuned!',
  },
  contact: {
    title: 'Contact',
    subtitle: "Let's work together",
    nameLabel: 'Name',
    emailLabel: 'Your Email',
    subjectLabel: 'Subject',
    messageLabel: 'Message',
    sendBtn: 'Send Message',
    sending: 'Sending...',
    successMsg: 'Message sent successfully! I\'ll get back to you soon.',
    errorMsg: 'Failed to send. Please try again.',
    connectLabel: 'Connect with me',
  },
  footer: {
    rights: 'All rights reserved.',
  },
};

const tr: Translations = {
  nav: {
    about: 'Hakkımda',
    experience: 'Deneyim',
    youtube: 'YouTube',
    blog: 'Blog',
    contact: 'İletişim',
  },
  hero: {
    greeting: 'Merhaba, ben',
    title: 'Kıdemli Full Stack Yazılım Geliştirici',
    bio: 'Tutku ile ölçeklenebilir web ve mobil uygulamalar geliştiriyorum. Amsterdam, Hollanda\'da yaşıyorum — aslen İstanbul\'dan.',
    cta: 'Çalışmalarıma Bak',
  },
  about: {
    title: 'Hakkımda',
    subtitle: 'Biraz kendimden',
    description:
      'On yılı aşkın deneyime sahip Kıdemli Full Stack Yazılım Geliştiriciyim. Oyun geliştirmeden mobil uygulamalara, büyük ölçekli web platformlarına kadar pek çok alanda çalıştım. Şu an Amsterdam\'da ikamet ediyorum; JavaScript, React Native, Node.js, .NET, 3D/WebGL ve daha fazlasını kapsayan çok yönlü bir yetenek setine sahibim.',
    skillsTitle: 'Beceriler & Teknolojiler',
    locationLabel: 'Konum',
    location: 'Amsterdam, Hollanda',
  },
  experience: {
    title: 'Deneyim',
    subtitle: 'Profesyonel yolculuğum',
    present: 'Günümüz',
  },
  youtube: {
    title: 'YouTube',
    subtitle: 'Eğitim içerikleri & öğreticiler',
    watchBtn: 'Videoyu İzle',
    channelBtn: 'Kanala Git',
    stats: '1.92K abone · 19 video · 200K+ izlenme',
  },
  blog: {
    title: 'Blog',
    subtitle: 'Düşünceler & makaleler',
    comingSoon: 'Yakında',
    comingSoonDesc: 'Yazılım geliştirme, mimari ve deneyimlerim hakkında makaleler hazırlıyorum. Takipte kalın!',
  },
  contact: {
    title: 'İletişim',
    subtitle: 'Birlikte çalışalım',
    nameLabel: 'Ad',
    emailLabel: 'E-posta',
    subjectLabel: 'Konu',
    messageLabel: 'Mesaj',
    sendBtn: 'Mesaj Gönder',
    sending: 'Gönderiliyor...',
    successMsg: 'Mesajınız başarıyla gönderildi! En kısa sürede dönüş yapacağım.',
    errorMsg: 'Gönderilemedi. Lütfen tekrar deneyin.',
    connectLabel: 'Bağlantı kur',
  },
  footer: {
    rights: 'Tüm hakları saklıdır.',
  },
};

const es: Translations = {
  nav: {
    about: 'Sobre mí',
    experience: 'Experiencia',
    youtube: 'YouTube',
    blog: 'Blog',
    contact: 'Contacto',
  },
  hero: {
    greeting: 'Hola, soy',
    title: 'Desarrollador Full Stack Senior',
    bio: 'Construyendo aplicaciones web y móviles escalables con pasión. Basado en Ámsterdam — originalmente de Estambul.',
    cta: 'Ver Mi Trabajo',
  },
  about: {
    title: 'Sobre mí',
    subtitle: 'Un poco sobre mí',
    description:
      'Soy un Desarrollador Full Stack Senior con más de una década de experiencia...',
    skillsTitle: 'Habilidades & Tecnologías',
    locationLabel: 'Ubicación',
    location: 'Ámsterdam, Países Bajos',
  },
  experience: {
    title: 'Experiencia',
    subtitle: 'Mi trayectoria profesional',
    present: 'Presente',
  },
  youtube: {
    title: 'YouTube',
    subtitle: 'Contenido educativo & tutoriales',
    watchBtn: 'Ver Video',
    channelBtn: 'Ver Canal',
    stats: '1.92K suscriptores · 19 videos · 200K+ vistas',
  },
  blog: {
    title: 'Blog',
    subtitle: 'Pensamientos & artículos',
    comingSoon: 'Próximamente',
    comingSoonDesc: '¡Estoy trabajando en artículos sobre desarrollo de software!',
  },
  contact: {
    title: 'Contacto',
    subtitle: 'Trabajemos juntos',
    nameLabel: 'Nombre',
    emailLabel: 'Tu correo',
    subjectLabel: 'Asunto',
    messageLabel: 'Mensaje',
    sendBtn: 'Enviar Mensaje',
    sending: 'Enviando...',
    successMsg: '¡Mensaje enviado! Me pondré en contacto contigo pronto.',
    errorMsg: 'Error al enviar. Por favor intenta de nuevo.',
    connectLabel: 'Conéctate conmigo',
  },
  footer: {
    rights: 'Todos los derechos reservados.',
  },
};

const nl: Translations = {
  nav: {
    about: 'Over mij',
    experience: 'Ervaring',
    youtube: 'YouTube',
    blog: 'Blog',
    contact: 'Contact',
  },
  hero: {
    greeting: 'Hoi, ik ben',
    title: 'Senior Full Stack Softwareontwikkelaar',
    bio: 'Ik bouw schaalbare web- en mobiele applicaties met passie. Gevestigd in Amsterdam, Nederland — oorspronkelijk uit Istanbul.',
    cta: 'Bekijk Mijn Werk',
  },
  about: {
    title: 'Over mij',
    subtitle: 'Een beetje over mij',
    description: 'Ik ben een Senior Full Stack Softwareontwikkelaar met meer dan tien jaar ervaring in het bouwen van digitale producten. Van game-ontwikkeling en mobiele apps tot grootschalige webplatforms. Momenteel woonachtig in Amsterdam met een veelzijdige skillset: JavaScript, React Native, Node.js, .NET, 3D/WebGL en meer.',
    skillsTitle: 'Vaardigheden & Technologieën',
    locationLabel: 'Locatie',
    location: 'Amsterdam, Nederland',
  },
  experience: {
    title: 'Ervaring',
    subtitle: 'Mijn professionele reis',
    present: 'Heden',
  },
  youtube: {
    title: 'YouTube',
    subtitle: 'Educatieve content & tutorials',
    watchBtn: 'Video Bekijken',
    channelBtn: 'Kanaal Bekijken',
    stats: '1,92K abonnees · 19 video\'s · 200K+ weergaven',
  },
  blog: {
    title: 'Blog',
    subtitle: 'Gedachten & artikelen',
    comingSoon: 'Binnenkort',
    comingSoonDesc: 'Ik werk aan artikelen over softwareontwikkeling, architectuur en mijn ervaringen. Blijf op de hoogte!',
  },
  contact: {
    title: 'Contact',
    subtitle: 'Laten we samenwerken',
    nameLabel: 'Naam',
    emailLabel: 'Jouw e-mail',
    subjectLabel: 'Onderwerp',
    messageLabel: 'Bericht',
    sendBtn: 'Bericht Versturen',
    sending: 'Versturen...',
    successMsg: 'Bericht succesvol verzonden! Ik neem snel contact met je op.',
    errorMsg: 'Verzenden mislukt. Probeer het opnieuw.',
    connectLabel: 'Verbind met mij',
  },
  footer: {
    rights: 'Alle rechten voorbehouden.',
  },
};

interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: Translations;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export const LanguageProvider = ({ children }: { children: ReactNode }) => {
  const detectLanguage = (): Language => {
    const nav = navigator.language || 'en';
    const code = nav.toLowerCase().slice(0, 2);
    if (code === 'tr') return 'tr';
    if (code === 'es') return 'es';
    if (code === 'nl') return 'nl';
    return 'en';
  };
  const [language, setLanguage] = useState<Language>(detectLanguage);
  const t = language === 'tr' ? tr : language === 'es' ? es : language === 'nl' ? nl : en;
  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = (): LanguageContextType => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be inside LanguageProvider');
  return ctx;
};
